const initialState = {};
const reducer = (state = initialState, action) => {
  if (action.type === "STORESEARCH") {
    return {
      ...state,
      currentSearchState: action.searchState,
    };
  } else if (action.type === "GETCURRENTSEARCH") {
    return state.currentSearchState;
  } else if (action.type === "STOREBASICSEARCH") {
    return {
      ...state,
      currentBasicSearchState: action.basicSearchState,
    };
  } else if (action.type === "GETCURRENTBASICSEARCH") {
    return state.currentBasicSearchState;
  } else if (action.type === "STOREADVANCESEARCH") {
    return {
      ...state,
      currentAdvanceSearchState: action.advanceSearchState,
    };
  } else if (action.type === "GETCURRENTADVANCESEARCH") {
    return state.currentAdvanceSearchState;
  }
  return state;
};

export default reducer;
